const encode = (value) => encodeURIComponent(String(value));

/** Initiatives live under the agent that owns them. */
export const agentInitiativePath = (agentId, initiativeId) =>
  `/app/agents/${encode(agentId)}/initiatives/${encode(initiativeId)}`;

/**
 * Link to an initiative. Without its owner, the stable /app/initiatives/:id link
 * resolves the owning agent and redirects (also used by stored and emailed links).
 */
export const initiativePath = (initiativeId, ownerAgentId = null) =>
  ownerAgentId ? agentInitiativePath(ownerAgentId, initiativeId) : `/app/initiatives/${encode(initiativeId)}`;

/** Every initiative across the team, for admins. */
export const ALL_WORK_PATH = '/app/team?view=work';
